import { render, staticRenderFns } from "./UserChangePasswordForm.vue?vue&type=template&id=05a955b8&scoped=true&"
import script from "./UserChangePasswordForm.vue?vue&type=script&lang=js&"
export * from "./UserChangePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a955b8",
  null
  
)

export default component.exports